// src/App.js
import React from 'react';
import ParallaxScene from './components/ParallaxScene';
import './App.css';

function App() {
  // オプション: カスタムレイヤーコンテンツを定義
  // const layerContents = [
  //   <div key="layer1">前景コンテンツ</div>,
  //   <div key="layer2">中間コンテンツ</div>,
  //   <div key="layer3">背景コンテンツ</div>,
  // ];
  
  return (
    <div className="app">
      <ParallaxScene 
        layerCount={5} 
        // layerContents={layerContents}
        initialSettings={{
          minDepth: -400,
          maxDepth: 0,
          minScale: 1.0,
          maxScale: 1.4
        }}
      />
    </div>
  );
}

export default App;